define(
    [
        'flightjs',
    ],

    function(flight) {

    'use strict';

    return flight.component(LoginRedirect);

    function LoginRedirect() {
        this.attributes({
            loginLinkSelector : '[data-globalnavui-loginlink]'
        });
        /**
         * Update the target component of the login url with the current
         * url. This is done on the front-end to improve cacheability.
         */
        this.after('initialize', function() {
            var $loginLink = this.select('loginLinkSelector');
            if ($loginLink.length) {
                var loginHref = $loginLink.attr('href');
                var currentUrl = encodeURIComponent(document.location.href);

                // Replace `return` parameter in direct-to-SSO link
                loginHref = loginHref.replace(/target=([^&]+)/, 'target=' + currentUrl);
                // Replace `from` parameter in simple `/login` link
                loginHref = loginHref.replace(/\bfrom=([^&]+)/, 'from=' + currentUrl);

                $loginLink.attr('href', loginHref);
            }
        });
    }
});



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/ui/login-redirect.js
 **/